import { render, staticRenderFns } from "./assetsInfo.vue?vue&type=template&id=6520f51e"
import script from "./assetsInfo.vue?vue&type=script&lang=js"
export * from "./assetsInfo.vue?vue&type=script&lang=js"
import style0 from "./assetsInfo.vue?vue&type=style&index=0&id=6520f51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports